import { z } from 'zod'
import { oc } from '@orpc/contract'
import { cellRefSchema } from './boards-shared.contract'

// The org-scoped board that AI-generated care tasks land on, plus the allowlist
// of care coordinators eligible for auto-assignment. Same GET/PUT shape as a
// single-value settings resource — `boards` and `candidates` are included on the
// get so the web panel doesn't need extra round-trips to list the org's boards
// or care coordinators.
//
// `assignees` is the currently-selected subset (bare Practitioner references);
// `candidates` is the org's full care-coordinator list ({reference, display}) to
// choose from. Only assignees still present in `candidates` are returned.
export const careTaskConfigGet = oc
  .route({ method: 'GET', path: '/v2/care-task-config' })
  .input(z.object({}).optional())
  .output(
    z.object({
      boardId: z.string().nullable(),
      labBoardId: z.string().nullable(),
      letterBoardId: z.string().nullable(),
      identityBoardId: z.string().nullable(),
      boards: z.array(z.object({ id: z.string(), name: z.string() })),
      assignees: z.array(z.string()),
      candidates: z.array(cellRefSchema),
    }),
  )

// Every field is independently optional, so each control saves only what it owns:
//   boardId/labBoardId/letterBoardId/identityBoardId
//                       omitted → keep stored; `null` → clear THAT board only;
//                       string  → set it (must belong to the caller's org).
//   assignees           omitted → keep stored; array → replace.
// The config Basic is never deleted here — see the handler.
export const careTaskConfigSet = oc
  .route({ method: 'PUT', path: '/v2/care-task-config' })
  .input(
    z.object({
      boardId: z.string().nullable().optional(),
      labBoardId: z.string().nullable().optional(),
      letterBoardId: z.string().nullable().optional(),
      identityBoardId: z.string().nullable().optional(),
      assignees: z.array(z.string()).optional(),
    }),
  )
  .output(
    z.object({
      boardId: z.string().nullable(),
      labBoardId: z.string().nullable(),
      letterBoardId: z.string().nullable(),
      identityBoardId: z.string().nullable(),
      assignees: z.array(z.string()),
    }),
  )
